export const MENSAGEM_CREDENCIAL_INVALIDA = "Usuário ou senha inválidos.";

export const MENSAGEM_VALIDADE_VENCIDA = "Usuário com validade vencida. Entre em contato com o administrador.";

const PREFIXO_BLOQUEIO = "Muitas tentativas de login";
const PREFIXO_EXCECAO_GRAPHQL = /^Exception while fetching data \([^)]*\) : /;

const removePrefixoGraphQL = (mensagem: any) =>
  typeof mensagem === "string" ? mensagem.replace(PREFIXO_EXCECAO_GRAPHQL, "") : mensagem;

export const mensagemErroLogin = (erro: any): string => {
  const graphQLErrors = (erro && erro.graphQLErrors) || [];
  const mensagem = graphQLErrors.length > 0 ? removePrefixoGraphQL(graphQLErrors[0].message) : null;
  if (mensagem === MENSAGEM_VALIDADE_VENCIDA) {
    return mensagem;
  }
  if (typeof mensagem === "string" && mensagem.startsWith(PREFIXO_BLOQUEIO)) {
    return mensagem;
  }
  return MENSAGEM_CREDENCIAL_INVALIDA;
};
